/*
 * Public API Surface of ai
 */

export * from './lib/aifs.routes';
export * from './lib/components/ai-file-grid-details/ai-file-grid-details.component';
export * from './lib/components/ai-grid-file/ai-grid-file.component';
export * from './lib/components/related-files-grid/related-files-grid.component';
export * from './lib/components/sia-workflow-configurator/sia-workflow-configurator.component';
export * from './lib/pages/ai-files-grid/ai-files-grid.component';
export * from './lib/pages/ai-assistant/ai-assistant.component';
export * from './lib/pipes/format-extracted-value.pipe';
